<template>
    <div v-for="item in items" class="list-item">
        <a v-if="item.images.length"
           :href="'/product/' + item.slug" class="list-item-img"
           :style="'background-image: url(\'' + item.images[0].thumbnail + '\')'"
        >
            <div v-if="item.is_new || item.is_sale || item.is_bestseller" class="tag tag-whitebg">
                <i v-if="item.is_new" class="bi bi-tags-fill"></i><ins>Новинка</ins>
                <i v-if="item.is_sale" class="bi bi-lightning-fill"></i><ins>Распродажа</ins>
                <i v-if="item.is_bestseller" class="bi bi-arrow-up-circle-fill"></i><ins>Лидер продаж</ins>
            </div>
        </a>
        <a v-else :href="'/product/' + item.slug" class="list-item-img"
           style="background-image: url(/i/nophoto.png)"
        >
            <div v-if="item.is_new || item.is_sale || item.is_bestseller" class="tag tag-whitebg">
                <i v-if="item.is_new" class="bi bi-tags-fill"></i><ins>Новинка</ins>
                <i v-if="item.is_sale" class="bi bi-lightning-fill"></i><ins>Распродажа</ins>
                <i v-if="item.is_bestseller" class="bi bi-arrow-up-circle-fill"></i><ins>Лидер продаж</ins>
            </div>
        </a>
        <div class="list-item-price item-price item-price-h3">
            <template v-if="item.price_old">
                <strike class="price-old">{{ item.price_old_formatted }}</strike>
                <strong class="price-off">{{ item.discount }}%</strong>
            </template>
            <span class="price-current">{{ item.price_formatted }}Р</span>
        </div>
        <div class="list-item-control item-control">
            <cart-add-button id="{{ item.id }}"></cart-add-button>
            <favourites-add-button v-if="isAuth" id="{{ item.id }}"></favourites-add-button>
        </div>
<!--        @if ($product->arrivals()->first())-->
        <div class="list-item-stock item-stock danger">
            Поставка 2024-11-11
        </div>
<!--        @endif-->
        <a :href="'/product/' + item.slug" class="list-item-link item-link">{{ item.name }}</a>
    </div>
</template>

<script>
export default {
    props: ["id", "url", "items"],
    data: function () {
        return {
        };
    },
    methods: {
    },
    computed: {
        isAuth() {
            return this.$store.state.isAuth;
        },

        // email() {
        //     return this.$store.state.email;
        // },
        //
        // phone() {
        //     return this.$store.state.phone;
        // },
    },
};
</script>
